import { Component } from '@angular/core';
import { HttpService } from '../service/http.service';
import { AgentCommissionListItem } from '../agent-commission-list-item';
import Decimal from 'decimal.js';
import { SalesAgent } from '../sales-agent';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-agent-commission',
  templateUrl: './agent-commission.component.html',
  styleUrls: ['./agent-commission.component.css']
})
export class AgentCommissionComponent {
  agents: SalesAgent[] = [new SalesAgent("Walter", 139)];
  commissions: AgentCommissionListItem[] = [];
  commissionRate: number = 40;
  ONE_HUNDRED: Decimal = new Decimal(100);
  BRUGES_INVOICE_RATE: Decimal = new Decimal(0.85);
  baseUrl: string = environment.lvConnectBaseUrl;
  filteredCommissions: AgentCommissionListItem[] = [];
  totalCommission: Decimal = new Decimal(0);
  filterMode: string = "Default";

  constructor(
    private httpService: HttpService,
    private router: Router
  ) {
    httpService.getSalesAgentCommissions().subscribe((res: AgentCommissionListItem[]) => {
      this.commissions = res;
      for (let commission of this.commissions) {
        commission.commissionStr = new Decimal(commission.grossMargin).times(new Decimal(this.commissionRate).div(this.ONE_HUNDRED)).toFixed(2);
        if (commission.totalSchoolInvoice == 0) {
          commission.info = "School Invoice missing";
        }
        this.totalCommission = this.totalCommission.add(new Decimal(commission.commissionStr));
      }
      this.applyDefaultFilter();
    });
  }

  updatePaidState() {
    this.router.navigate(["/management/agent-commissions-update"]);
  }

  paidAlreadyFilterChange(checked: boolean){
      this.filteredCommissions = this.commissions.filter(record => record.isCommissionPaid === checked);
      this.totalCommission = new Decimal(0);
      for (let commission of this.filteredCommissions) {
        this.totalCommission = this.totalCommission.add(new Decimal(commission.commissionStr));
      }
      this.filterMode = "Already paid to agent";
  }

  applyDefaultFilter(){
    this.filteredCommissions = this.commissions.filter(record => record.isCommissionPaid === false && record.commissionStr != "0.00");
    this.filterMode = "Default";
  }

}
